import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from '../../Navigation/header/header';
import { Footer } from '../../Navigation/footer/footer';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, Header, Footer],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout {}
